/*
 * @Author: 黄浩
 * @Date: 2021-07-11 08:56:29
 * @LastEditTime: 2021-10-15 14:29:43
 * @LastEditors: Please set LastEditors
 * @Descripttion:
 * @FilePath: \dhr_frontend\src\routes\modules\IntegrityZon.js
 */
export default [
  {
    name: "SunshineAmbassador",
    path: "/IntegrityZon/SunshineAmbassador/list",
    component: () => import("@/views/IntegrityZon/SunshineAmbassador/list.vue"),
    meta: {
      title: "阳光大使设置",
    },
  },
  {
    name: "SunshineAmbassadorDetail",
    path: "/IntegrityZon/SunshineAmbassador/detail",
    component: () =>
      import("@/views/IntegrityZon/SunshineAmbassador/detail.vue"),
    meta: {
      parentAuth: "/IntegrityZon/SunshineAmbassador/list",
      title: "阳光大使详情",
    },
  },
  {
    name: "IntegrityReport",
    path: "/IntegrityZon/Report/list",
    component: () => import("@/views/IntegrityZon/Report/list.vue"),
    meta: {
      title: "廉洁举报",
    },
  },
  {
    name: "IntegrityReportDetail",
    path: "/IntegrityZon/Report/detail",
    component: () => import("@/views/IntegrityZon/Report/detail.vue"),
    meta: {
      parentAuth: "/IntegrityZon/Report/list",
      title: "廉洁举报详情",
    },
  },
  {
    name: "banner",
    path: "/IntegrityZon/banner/index",
    component: () => import("@/views/IntegrityZon/banner/index.vue"),
    meta: {
      title: "banner管理",
    },
  },
  {
    name: "baseBonfig",
    path: "/IntegrityZon/baseBonfig",
    component: () =>
      import("@/views/IntegrityZon/mentalJourneyProject/baseBonfig/index.vue"),
    meta: {
      title: "基础配置",
    },
  },
  {
    name: "mentalJourney",
    path: "/IntegrityZon/mentalJourney",
    component: () =>
      import(
        "@/views/IntegrityZon/mentalJourneyProject/mentalJourney/index.vue"
      ),
    meta: {
      title: "心路之旅",
    },
  },
  {
    name: "charityManagement",
    path: "/IntegrityZon/charityManagement",
    component: () =>
      import(
        "@/views/IntegrityZon/mentalJourneyProject/charityManagement/index.vue"
      ),
    meta: {
      title: "慈善会成员",
    },
  },
  {
    name: "mentalProjectList",
    path: "/IntegrityZon/mentalProject/list",
    component: () =>
      import(
        "@/views/IntegrityZon/mentalJourneyProject/mentalProject/list.vue"
      ),
    meta: {
      title: "心路项目",
    },
  },
  {
    name: "mentalProjectPreview",
    path: "/IntegrityZon/mentalProject/preview",
    component: () =>
      import(
        "@/views/IntegrityZon/mentalJourneyProject/mentalProject/detail/preview/index.vue"
      ),
    meta: {
      title: "心路项目预览",
      parentAuth: "/IntegrityZon/mentalProject/list",
    },
  },
  {
    name: "mentalProjectDetail",
    path: "/IntegrityZon/mentalProject/detail",
    component: () =>
      import(
        "@/views/IntegrityZon/mentalJourneyProject/mentalProject/detail/detail.vue"
      ),
    meta: {
      parentAuth: "/IntegrityZon/mentalProject/list",
      title: "项目维护",
    },
  },
  {
    name: "mentalProjectFundraisingList",
    path: "/IntegrityZon/mentalProject/fundraisingList",
    component: () =>
      import(
        "@/views/IntegrityZon/mentalJourneyProject/mentalProject/fundraisingList.vue"
      ),
    meta: {
      parentAuth: "/IntegrityZon/mentalProject/list",
      title: "募捐名单",
    },
  },
];
